<template>
  <div>

    <v-toolbar-title>{{ this.catname }}</v-toolbar-title>
    <v-row>
      <v-col style="padding: 2%">
        <v-col cols="12" sm="12" md="3">
          <v-btn @click="goToPage('/templateName')" class="white--text">
            Add Sub category 
          </v-btn>
        </v-col>
        <v-row style="padding: 1%">
          <v-col cols="12" sm="12" md="3">
            <v-text-field
              placeholder="Search Template"
              v-model="search"
              class="field"
              append-outer-icon="mdi-magnify"
              height="10"
              style="padding-right: 12px"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              @change="getCategories"
              flat
              v-model="sortBy"
              solo
              class="field"
              append-outer-icon="mdi-menu-down"
              hide-details
              :items="sortOptions"
              label="Sort By..."
              style="padding-right: 12px"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
    <!-- Display fetched templates -->
    <v-row>
      <v-col v-for="(category, index) in categories" :key="index" cols="12" sm="6" md="4">
        <v-card @click="viewCategory(category)" class="template-card d-flex flex-column align-center">
          <v-img :src="category.imagePath || 'placeholder_image_url_here'" height="150" width="150"  class="image-container">
          </v-img>
          <v-card-title class="text-center">{{ category.name }}</v-card-title>
        </v-card> 
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: "App",
  data() {
    return {
      catname: "",
      search: "",
      sortBy: "", // Sorting option selected by the user
      sortOptions: ["Default", "Name", "Date"], // Sorting options for the dropdown
      categories: [], // Array to store fetched templates
      selectedId: null // Initialize selectedId
    };
  },
  methods: {
    async getCategories() {
      // Use this.selectedId instead of $data.selectedId
      console.error("fetching categories:", this.selectedId);
      try {
        let querySnapshot;
        if (this.sortBy === "Name") {
          querySnapshot = await getDocs(collection(db, "Category").orderBy("name"));
        } else if (this.sortBy === "Date") {
          querySnapshot = await getDocs(collection(db, "Category").orderBy("createdAt"));
        } else {
          // Pass selectedId to the query
          querySnapshot = await getDocs(collection(db, 'Category', this.selectedId, 'subcategories'));
        }
        const categories = querySnapshot.docs.map(doc => {
          const data = doc.data();
          // Assuming each template document contains an "imageUrl" field for the image URL
          // Adjust this according to your actual data structure
          data.imagePath = data.imagePath || null;
          data.templateId = data.templateId // Set default value to null if empty
          return data;
        });
        this.categories = categories;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    viewCategory(category) {
      // Handle viewing category
    },
    goToPage(path) {
      // Use this.selectedId instead of $data.selectedId
      console.error("fetching categories: 11", this.selectedId);
      this.$router.push({ name: 'templateName', params: {selectedId : this.selectedId } });
    }
  },
  created() {
    // Initialize selectedId when the component is created
    this.selectedId = this.$route.params.selectedId;
    this.catname = this.$route.params.catname;
    
    this.getCategories(); // Fetch templates when the component is created
  }
};
</script>

<style scoped>
.v-input input {
  height: 10px;
}
.text-start {
  background-color: #4b4b4b;
}
.v-text-field {
  border: 1px solid black;
  height: 50px;
}
.white--text {
  background: rgb(23, 74, 133);
  background: linear-gradient(
    rgba(0,129,128,255) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 100%;
}
.field {
  height: 50px;
  background: #00d200;
}
.card-content {
  color: rgb(7, 4, 4);
  padding: 10px;
  width: 100;
  box-sizing: border-box;
  text-align: center;
}
</style>
